import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import Header from './components/Header'
import Navigation from './components/Navigation'
import MatchesList from './pages/MatchesList'
import MatchDetail from './pages/MatchDetail'
import VodHighlightsList from './pages/VodHighlightsList'
import VodHighlightDetail from './pages/VodHighlightDetail'
import CompetitionsList from './pages/CompetitionsList'
import TournamentCreate from './pages/TournamentCreate'
import TournamentDetail from './pages/TournamentDetail'
import ComplexesList from './pages/ComplexesList'
import ComplexDetail from './pages/ComplexDetail'
import PlayersList from './pages/PlayersList'
import PlayerDetail from './pages/PlayerDetail'
import TeamsList from './pages/TeamsList'
import TeamDetail from './pages/TeamDetail'
import FeedMapping from './pages/FeedMapping'
import LiveControl from './pages/LiveControl'
import './App.scss'
import MatchBriefingPage from './pages/MatchBriefingPage'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <ProtectedRoute>
              <Header />
              <Navigation />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Navigate to="/matches" replace />} />
                  <Route path="/live" element={<LiveControl />} />
                  <Route path="/matches" element={<MatchesList />} />
                  <Route path="/matches/:matchId" element={<MatchDetail />} />
                  <Route path="/vod-highlights" element={<VodHighlightsList />} />
                  <Route path="/vod-highlights/:highlightId" element={<VodHighlightDetail />} />
                  <Route path="/tournaments" element={<CompetitionsList />} />
                  <Route path="/tournaments/new" element={<TournamentCreate />} />
                  <Route path="/tournaments/:tournamentId" element={<TournamentDetail />} />
                  <Route path="/players" element={<PlayersList />} />
                  <Route path="/players/:playerId" element={<PlayerDetail />} />
                  <Route path="/teams" element={<TeamsList />} />
                  <Route path="/teams/:teamId" element={<TeamDetail />} />
                  <Route path="/courts" element={<ComplexesList />} />
                  <Route path="/courts/:complexId" element={<ComplexDetail />} />
                  <Route path="/feed-mapping" element={<FeedMapping />} />
                  <Route path="/match-briefing" element={<MatchBriefingPage />} />
                </Routes>
              </main>
            </ProtectedRoute>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
